import { ComicCard } from './components/ComicCard';
import { HeroBanner } from './components/HeroBanner';
import { RankingList } from './components/RankingList';
import { CategoryGrid } from './components/CategoryGrid';
import { CTASection } from './components/CTASection';
import { LatestUpdatesSection } from './components/LatestUpdatesSection';
import { FeaturedSection } from './components/FeaturedSection';
import SEOHead from '@/components/feature/SEOHead';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '妖精漫画网 - 韩国漫画大全',
  description: '妖精漫画网是最全的韩国漫画在线阅读平台，提供下拉式韩漫大全、免费漫画在线观看服务。',
  url: 'http://lvtianyuan.com/',
  isPartOf: {
    '@type': 'WebSite',
    name: '妖精漫画网',
    url: 'http://lvtianyuan.com/',
  },
  primaryImageOfPage: {
    '@type': 'ImageObject',
    url: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20collection%20banner%2C%20colorful%20manga%20covers%20collage%2C%20warm%20lighting%2C%20library%20atmosphere&width=1200&height=630&seq=og-homepage&orientation=landscape',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="妖精漫画网_韩国漫画_下拉式韩漫大全_最全的韩漫网_免费漫画在线观看"
        description="妖精漫画网是最全的韩国漫画在线阅读平台，提供下拉式韩漫大全、免费漫画在线观看服务。每日更新海量热门韩漫，涵盖浪漫爱情、奇幻冒险、动作热血等十大类型。"
        keywords="妖精漫画网,韩国漫画,下拉式韩漫大全,最全的韩漫网,免费漫画在线观看"
        canonicalUrl="http://lvtianyuan.com/"
        ogImage="https://readdy.ai/api/search-image?query=Korean%20manhwa%20collection%20banner%2C%20colorful%20manga%20covers%20collage%2C%20warm%20lighting%2C%20library%20atmosphere&width=1200&height=630&seq=og-homepage&orientation=landscape"
        jsonLd={homeJsonLd}
      />
      <HeroBanner />
      <RankingList />
      <FeaturedSection />
      <LatestUpdatesSection />
      <CategoryGrid />
      <CTASection />
    </>
  );
}